import { DOCUMENT_SEARCH } from '@Constants/types';

const initialState = {
    navigating: false,
    navigatingTo: {},
    lastNavigateTo: {},
    navigationFailedFlag: false,
    clearNavigateCountFlag: false,
    mixpanelSearchTimeStamp: new Date(),
    mixpanelSearchDuration: 0
    // searchCount: 0
};

export default function searchReducer(state = initialState, action) {
    switch (action.type) {
        case DOCUMENT_SEARCH.SEARCH_REQUEST:
            return {
                ...state,
                navigating: true,
                navigationFailedFlag: false,
                navigatingTo: action.payload,
                mixpanelSearchTimeStamp: new Date()
            };
        case DOCUMENT_SEARCH.SEARCH_SUCCESS:
            const mixpanelSearchStartTimeStamp = state.mixpanelSearchTimeStamp;
            const mixpanelSearchEndTimeStamp = new Date();
            const durationInMilliseconds =
                mixpanelSearchEndTimeStamp.getTime() - mixpanelSearchStartTimeStamp.getTime();
            return {
                ...state,
                navigating: false,
                lastNavigateTo: state.navigatingTo,
                navigatingTo: -1,
                mixpanelSearchDuration: durationInMilliseconds
            };
        case DOCUMENT_SEARCH.SEARCH_FAILURE:
            return {
                ...state,
                navigating: false,
                navigationFailedFlag: true
            };
        case DOCUMENT_SEARCH.SEARCH_INDEX_CLEAR:
            return {
                ...state,
                clearNavigateCountFlag: !state.clearNavigateCountFlag
            };
        // case DOCUMENT_SEARCH.COUNT_REQUEST:
        //     return {
        //         ...state,
        //         searchCount: 0
        //     };
        // case DOCUMENT_SEARCH.COUNT_SUCCESS:
        //     return {
        //         ...state,
        //         searchCount: action.payload
        //     };
        // case DOCUMENT_SEARCH.COUNT_FAILURE:
        //     return {
        //         ...state,
        //         searchCount: 0
        //     };
        default:
            return state;
    }
}
